import {SigninFormComponent} from '../../signin-form-component';
import {SIGN_TYPE, setSignType} from '../../sign-type';

Hop.defineModule('forms.signin', (root, param) => {
    // TODO : this class instance is almost useless, need refacto without it
    const signinComponent = new SigninFormComponent(root, param, () => {
        setSignType(SIGN_TYPE.SIGNUP);
    });

    storeSignin();

    function storeSignin() {
        Hop.storeObj(signinComponent);
    }

    function destroySigninObj() {
        Hop.destroyObj(signinComponent.id);
    }

    return function destroy() {
        destroySigninObj();
        signinComponent.destroy();
    };
});
